export const Positions = {
  CITY: 'CITY',
  DUNGEON: 'DUNGEON',
  DUNGEON_WIN: 'DUNGEON_WIN',
  DUNGEON_CHALLENGE: 'DUNGEON_CHALLENGE',
  DUNGEON_CHALLENGE_WIN: 'DUNGEON_CHALLENGE_WIN',
  STADION: 'STADION',
  LEAGUE_REGISTER: 'LEAGUE_REGISTER',
  LEAGUE_OAK: 'LEAGUE_OAK',
  LEAGUE_FIGHT: 'LEAGUE_FIGHT',
  MEWTWO_FIGHT: 'MEWTWO_FIGHT',
  LEAGUE_WIN: 'LEAGUE_WIN',
  LEAGUE_LOSE: 'LEAGUE_LOSE',
  WILD: 'WILD',
  FIGHT: 'FIGHT',
  FIGHT_TRAINER: 'FIGHT_TRAINER',
  FIGHT_TEAM_ROCKET: 'FIGHT_TEAM_ROCKET',
  FIGHT_STADION_TRAINER_WIN: 'FIGHT_STADION_TRAINER_WIN',
  FIGHT_WILD_TRAINER_WIN: 'FIGHT_WILD_TRAINER_WIN',
  MEWTWO_FIGHT_WIN: 'MEWTWO_FIGHT_WIN',
  FIGHT_TEAM_ROCKET_WIN: 'FIGHT_TEAM_ROCKET_WIN',
  WILD_OBSTACLE: 'WILD_OBSTACLE',
  ENCOUNTER: 'ENCOUNTER',
  OAK: 'OAK',
  TUTORIAL_OAK: 'TUTORIAL_OAK',
  OFFICER_JENNY: 'OFFICER_JENNY',
  START: 'START',
}

export const WildType = {
  NEUTRAL: 'NEUTRAL',
  VULCAN: 'VULCAN',
  FOREST: 'FOREST',
  FACTORY: 'FACTORY',
  SEA: 'SEA',
  MOUNTAINS: 'MOUNTAINS',
  PLAINS: 'PLAINS',
  CAVE: 'CAVE',
  TROPIC: 'TROPIC',
  RUINS: 'RUINS',

}

